import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=506a40d8&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=506a40d8&lang=scss&scoped=true&"
import style1 from "./Edit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506a40d8",
  null
  
)

export default component.exports